import Separator from '../../shared/separator';
import { IMobileTopMenuTabSection } from '../interfaces';
import { logout } from '../../../membership/dal/data-provider';
import { useAppDispatch, rootActions, useAppSelector } from '../data/store';
import { getSelectedTab } from '../domain/mobile-top-menu-provider';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { Fragment } from 'react';

interface ITabSection {
    section: IMobileTopMenuTabSection;
    isLastSection: boolean;
    hasMembership: boolean;
}

const DEFAULT_LINK_CLASSES = 'text-lg text-gray-400 no-underline text-left';

const TabSection = (props: ITabSection) => {

    const dispatch = useAppDispatch();

    const data = useAppSelector(store => store.root.data);
    const selectedTabId = useAppSelector(store => store.root.selectedTabId);
    const selectedTab = getSelectedTab(data, selectedTabId);
    const tabName = selectedTab?.tabName || '';

    const { section, isLastSection, hasMembership } = props;

    const isHorizontal = section.orientation === 'horizontal';

    const signOut = async () => {
        dispatch(rootActions.main({
            isLoggedIn: false,
            userName: '',
        }));

        dispatch(rootActions.toggle({
            isOpened: false,
        }));

        await logout();
        window.location.reload();
    };

    /* eslint-disable react/jsx-no-target-blank  */
    return (
        <section className="flex flex-col">
            {
                section.sectionTitle &&
                <p className="font-medium uppercase text-sm mb-3 text-gray-450">{ section.sectionTitle }</p>
            }

            <div className={ `flex ${ isHorizontal ? 'flex-row items-center flex-wrap' : 'flex-col' }` }>
                {
                    section.sectionItems.map((item, i) => {

                        const text = item.text;

                        if(item.hidden) return <Fragment  key={ `${ section.id }-${ text }-${ i }` } />

                        const shouldOpenNewTab = item.link?.startsWith('http') ?? false;
                        const linkClasses = item.design === 'button' ? 'flex items-center px-4 py-1 relative no-underline bg-yellow-400 text-gray-700 rounded-3xl font-bold w-auto inline-block mr-auto ml-px' : DEFAULT_LINK_CLASSES;

                        return (
                            <a
                                key={ `${ section.id }-${ text }-${ i }` }
                                href={ item.link }
                                target={ shouldOpenNewTab ? '_blank' : '_self' }
                                rel={ shouldOpenNewTab ? 'noreferrer' : '' }
                                className={ `${ linkClasses } mb-3 whitespace-nowrap ${ isHorizontal ? 'mr-2' : '' }` }
                                onClick={ () => {
                                    const gaValue = tabName ? `${ tabName } > ${ text }` : text;
                                    sendGAEvent('Top Menu', gaValue);
                                }}
                                title="">
                                { text}
                            </a>
                        )
                    })
                }

                {
                    hasMembership && isLastSection &&
                    <button
                        type="button"
                        onClick={ signOut }
                        className={ `${ DEFAULT_LINK_CLASSES } mb-3 whitespace-nowrap` }>Sign out</button>
                }
            </div>

            { !isLastSection && <Separator margin="mt-3 mb-6" color="#474747" /> }
        </section>
    )
};

export default TabSection;